export const baseUrl = {
  primary: process.env.VUE_APP_BASE_URL,
  uploadHost: process.env.VUE_APP_UPLOAD_HOST,
  uploadKey: process.env.VUE_APP_UPLOAD_KEY,
  uploadSecret: process.env.VUE_APP_UPLOAD_SECRET,
  newprimary: process.env.VUE_APP_BASE_URL2,
  website: process.env.VUE_APP_WEBSITE_URL,
  sunlightWebsite: process.env.VUE_APP_SUNLIGHT_URL,
  appletPage: process.env.VUE_APP_APPLET_PAGE
}
